import { observer } from 'mobx-react-lite';

import * as styles from './PaginationExtraLabel.css';

function PaginationExtraLabel({
  currentResults,
  total
}: {
  currentResults: number;
  total: number;
}) {
  return (
    <p className={styles.TextStyle}>
      Mostrando <strong>{currentResults} </strong>
      de <strong>{total}</strong> resultados
    </p>
  );
}

export default observer(PaginationExtraLabel);
